export default "__VITE_ASSET__BGqVAG3R__"